import { ReportData } from '../types/reportTypes';

// Parse currency string to number
const parseCurrency = (value: string): number => {
  if (!value || value === '') return 0;
  return parseFloat(value.replace(/[$,]/g, ''));
};

// Parse percentage string to number
const parsePercentage = (value: string): number => {
  if (!value || value === '') return 0;
  return parseFloat(value.replace(/%/g, '')) / 100;
};

// July 2025 Sales Data - Standard Report (Updated with corrected totals from CSV)
const jobData = [
  {
    jobInfo: "E-496: Jessica Liu",
    leadSource: "Yelp",
    trade: "Gutters",
    contractTotal: 1265.00,
    grossMarginPct: 0.6783,
    grossProfit: 858.05,
    commissionPercentage: 10.00,
    salesCommission: 126.50,
    salesManagerFee: 12.65,
    companyOH: 196.08,
    netProfit: 0
  },
  {
    jobInfo: "E-485: Bridget Jarmon",
    leadSource: "Angi",
    trade: "Attic Insulation",
    contractTotal: 2872.00,
    grossMarginPct: 0.6139,
    grossProfit: 1763.12,
    commissionPercentage: 10.00,
    salesCommission: 287.20,
    salesManagerFee: 28.72,
    companyOH: 445.16,
    netProfit: 0
  },
  {
    jobInfo: "E-488: Joanna Yala",
    leadSource: "Google Organic Search",
    trade: "Attic Insulation",
    contractTotal: 1521.00,
    grossMarginPct: 0.4395,
    grossProfit: 668.48,
    commissionPercentage: 4.00,
    salesCommission: 60.84,
    salesManagerFee: 15.21,
    companyOH: 235.76,
    netProfit: 0
  },
  {
    jobInfo: "E-479: Alexandria Meyerson",
    leadSource: "Google Organic Search",
    trade: "Attic Insulation",
    contractTotal: 3982.00,
    grossMarginPct: 0.6391,
    grossProfit: 2544.90,
    commissionPercentage: 10.00,
    salesCommission: 398.20,
    salesManagerFee: 39.82,
    companyOH: 617.21,
    netProfit: 0
  },
  {
    jobInfo: "E-486: Anthony & Emma Vaught",
    leadSource: "Angi",
    trade: "Attic Insulation",
    contractTotal: 2712.00,
    grossMarginPct: 0.6552,
    grossProfit: 1776.90,
    commissionPercentage: 10.00,
    salesCommission: 271.20,
    salesManagerFee: 27.12,
    companyOH: 420.36,
    netProfit: 0
  },
  {
    jobInfo: "E-511: Joe / Susan Maris / Anchors",
    leadSource: "Thumbtack",
    trade: "Attic Insulation",
    contractTotal: 1272.00,
    grossMarginPct: 0.4408,
    grossProfit: 560.70,
    commissionPercentage: 4.00,
    salesCommission: 50.88,
    salesManagerFee: 12.72,
    companyOH: 197.16,
    netProfit: 0
  },
  {
    jobInfo: "E-487: Gina Courtney",
    leadSource: "Thumbtack",
    trade: "Gutters",
    contractTotal: 700.00,
    grossMarginPct: 0.4269,
    grossProfit: 298.83,
    commissionPercentage: 4.00,
    salesCommission: 28.00,
    salesManagerFee: 7.00,
    companyOH: 108.50,
    netProfit: 0
  },
  {
    jobInfo: "E-476: Yofi Amsalu",
    leadSource: "Thumbtack",
    trade: "Attic Insulation",
    contractTotal: 4500.00,
    grossMarginPct: 0.6077,
    grossProfit: 2734.65,
    commissionPercentage: 10.00,
    salesCommission: 450.00,
    salesManagerFee: 45.00,
    companyOH: 697.50,
    netProfit: 0
  },
  {
    jobInfo: "E-463: John Keithley",
    leadSource: "Google Organic Search",
    trade: "Roofing",
    contractTotal: 7836.00,
    grossMarginPct: 0.6192,
    grossProfit: 4852.05,
    commissionPercentage: 10.00,
    salesCommission: 783.60,
    salesManagerFee: 78.36,
    companyOH: 1214.58,
    netProfit: 0
  },
  {
    jobInfo: "E-453: Heather & William Ross",
    leadSource: "Thumbtack",
    trade: "Gutters",
    contractTotal: 4721.00,
    grossMarginPct: 0.4424,
    grossProfit: 2088.57,
    commissionPercentage: 4.00,
    salesCommission: 188.84,
    salesManagerFee: 47.21,
    companyOH: 731.76,
    netProfit: 0
  },
  {
    jobInfo: "E-457: Sharon Spratley",
    leadSource: "Google Organic Search",
    trade: "Roofing",
    contractTotal: 9122.00,
    grossMarginPct: 0.4399,
    grossProfit: 4012.77,
    commissionPercentage: 4.00,
    salesCommission: 364.88,
    salesManagerFee: 91.22,
    companyOH: 1413.91,
    netProfit: 0
  },
  {
    jobInfo: "E-456: Gurmehar & Rupinder Cheema",
    leadSource: "Google Organic Search",
    trade: "Gutters",
    contractTotal: 2212.00,
    grossMarginPct: 0.6301,
    grossProfit: 1393.78,
    commissionPercentage: 10.00,
    salesCommission: 221.20,
    salesManagerFee: 22.12,
    companyOH: 342.86,
    netProfit: 0
  },
  {
    jobInfo: "E-450: Kevin Van Buskirk",
    leadSource: "Thumbtack",
    trade: "Attic Insulation",
    contractTotal: 2649.00,
    grossMarginPct: 0.6152,
    grossProfit: 1629.66,
    commissionPercentage: 10.00,
    salesCommission: 264.90,
    salesManagerFee: 26.49,
    companyOH: 410.60,
    netProfit: 0
  },
  {
    jobInfo: "E-513: Rachel Small",
    leadSource: "Web to Lead Form",
    trade: "Siding",
    contractTotal: 7948.28,
    grossMarginPct: 0.4753,
    grossProfit: 3777.82,
    commissionPercentage: 4.00,
    salesCommission: 317.93,
    salesManagerFee: 79.48,
    companyOH: 1231.98,
    netProfit: 0
  },
  {
    jobInfo: "E-547: Rudolph & Cynthia Foxwell",
    leadSource: "Web to Lead Form",
    trade: "Roofing",
    contractTotal: 12672.00,
    grossMarginPct: 0.3651,
    grossProfit: 4626.55,
    commissionPercentage: 0.00,
    salesCommission: 0.00,
    salesManagerFee: 126.72,
    companyOH: 1964.16,
    netProfit: 0
  },
  {
    jobInfo: "E-535: Monica & Ashlyn Howard",
    leadSource: "Yelp",
    trade: "Windows & Doors",
    contractTotal: 11828.00,
    grossMarginPct: 0.4376,
    grossProfit: 5175.93,
    commissionPercentage: 4.00,
    salesCommission: 473.12,
    salesManagerFee: 118.28,
    companyOH: 1833.34,
    netProfit: 0
  },
  {
    jobInfo: "E-508: Sara & Gareth Harr",
    leadSource: "Google Organic Search",
    trade: "Attic Insulation",
    contractTotal: 39778.00,
    grossMarginPct: 0.4172,
    grossProfit: 16595.38,
    commissionPercentage: 4.00,
    salesCommission: 1591.12,
    salesManagerFee: 397.78,
    companyOH: 6165.59,
    netProfit: 0
  },
  {
    jobInfo: "E-483: Dennis & Sheila Cuddy",
    leadSource: "Thumbtack",
    trade: "Gutters",
    contractTotal: 1121.00,
    grossMarginPct: 0.6486,
    grossProfit: 727.08,
    commissionPercentage: 10.00,
    salesCommission: 112.10,
    salesManagerFee: 11.21,
    companyOH: 173.76,
    netProfit: 0
  },
  {
    jobInfo: "E-546: Justin & Jennifer Blanche",
    leadSource: "Previous Customer",
    trade: "Windows & Doors",
    contractTotal: 8562.00,
    grossMarginPct: 0.4000,
    grossProfit: 3424.80,
    commissionPercentage: 4.00,
    salesCommission: 342.48,
    salesManagerFee: 85.62,
    companyOH: 1327.11,
    netProfit: 0
  },
  {
    jobInfo: "E-544: Keegan & John Hooks",
    leadSource: "Yelp",
    trade: "Windows & Doors",
    contractTotal: 10061.00,
    grossMarginPct: 0.5666,
    grossProfit: 5700.56,
    commissionPercentage: 7.00,
    salesCommission: 704.27,
    salesManagerFee: 100.61,
    companyOH: 1559.46,
    netProfit: 0
  },
  {
    jobInfo: "E-484: Lauren Hughes",
    leadSource: "Yelp",
    trade: "Roofing",
    contractTotal: 15492.00,
    grossMarginPct: 0.4640,
    grossProfit: 7188.29,
    commissionPercentage: 4.00,
    salesCommission: 619.68,
    salesManagerFee: 154.92,
    companyOH: 2401.26,
    netProfit: 0
  },
  {
    jobInfo: "E-506: Angie Brooks Wiggans",
    leadSource: "Thumbtack",
    trade: "Windows & Doors",
    contractTotal: 7500.00,
    grossMarginPct: 0.4083,
    grossProfit: 3062.25,
    commissionPercentage: 4.00,
    salesCommission: 300.00,
    salesManagerFee: 75.00,
    companyOH: 1162.50,
    netProfit: 0
  },
  {
    jobInfo: "E-520: Michael & Christine Robinson",
    leadSource: "Angi",
    trade: "Windows & Doors",
    contractTotal: 6837.00,
    grossMarginPct: 0.4012,
    grossProfit: 2743.00,
    commissionPercentage: 4.00,
    salesCommission: 273.48,
    salesManagerFee: 68.37,
    companyOH: 1059.74,
    netProfit: 0
  },
  {
    jobInfo: "E-512: William & Vanessa Cawthern",
    leadSource: "Google Organic Search",
    trade: "Gutters",
    contractTotal: 1815.00,
    grossMarginPct: 0.6456,
    grossProfit: 1171.76,
    commissionPercentage: 10.00,
    salesCommission: 181.50,
    salesManagerFee: 18.15,
    companyOH: 281.33,
    netProfit: 0
  },
  {
    jobInfo: "E-510: Clifton Gardner",
    leadSource: "Thumbtack",
    trade: "Attic Insulation",
    contractTotal: 5442.00,
    grossMarginPct: 0.7104,
    grossProfit: 3866.00,
    commissionPercentage: 10.00,
    salesCommission: 544.20,
    salesManagerFee: 54.42,
    companyOH: 843.51,
    netProfit: 0
  },
  {
    jobInfo: "E-525: Hope Simpara",
    leadSource: "Thumbtack",
    trade: "Roofing",
    contractTotal: 14950.00,
    grossMarginPct: 0.5876,
    grossProfit: 8784.62,
    commissionPercentage: 7.00,
    salesCommission: 1046.50,
    salesManagerFee: 149.50,
    companyOH: 2317.25,
    netProfit: 0
  },
  {
    jobInfo: "E-517: Reisha & Krishna Semper",
    leadSource: "Thumbtack",
    trade: "Roofing",
    contractTotal: 15918.79,
    grossMarginPct: 0.4911,
    grossProfit: 7817.72,
    commissionPercentage: 4.00,
    salesCommission: 636.75,
    salesManagerFee: 159.19,
    companyOH: 2467.41,
    netProfit: 0
  },
  {
    jobInfo: "E-519: Peter & Judith Klover",
    leadSource: "Thumbtack",
    trade: "Attic Insulation",
    contractTotal: 2361.00,
    grossMarginPct: 0.5439,
    grossProfit: 1284.15,
    commissionPercentage: 7.00,
    salesCommission: 165.27,
    salesManagerFee: 23.61,
    companyOH: 365.96,
    netProfit: 0
  },
  {
    jobInfo: "E-528: Billy & Patricia Reed",
    leadSource: "Homebuddy",
    trade: "Windows & Doors",
    contractTotal: 3221.00,
    grossMarginPct: 0.6017,
    grossProfit: 1938.08,
    commissionPercentage: 10.00,
    salesCommission: 322.10,
    salesManagerFee: 32.21,
    companyOH: 499.26,
    netProfit: 0
  },
  {
    jobInfo: "E-507: Jamille Grubb",
    leadSource: "Web to Lead Form",
    trade: "Roofing",
    contractTotal: 9468.00,
    grossMarginPct: 0.5116,
    grossProfit: 4843.83,
    commissionPercentage: 7.00,
    salesCommission: 662.76,
    salesManagerFee: 94.68,
    companyOH: 1467.54,
    netProfit: 0
  },
  {
    jobInfo: "E-521: Rufina & Chase Nelson",
    leadSource: "Thumbtack",
    trade: "Windows & Doors",
    contractTotal: 3372.00,
    grossMarginPct: 0.3887,
    grossProfit: 1310.70,
    commissionPercentage: 0.00,
    salesCommission: 0.00,
    salesManagerFee: 33.72,
    companyOH: 522.66,
    netProfit: 0
  },
  {
    jobInfo: "E-500: Cameron Thomas",
    leadSource: "Yelp",
    trade: "Roofing",
    contractTotal: 9022.00,
    grossMarginPct: 0.3729,
    grossProfit: 3364.30,
    commissionPercentage: 0.00,
    salesCommission: 0.00,
    salesManagerFee: 90.22,
    companyOH: 1398.41,
    netProfit: 0
  },
  {
    jobInfo: "E-518: Elie Littrell",
    leadSource: "Google Organic Search",
    trade: "Gutters",
    contractTotal: 2472.00,
    grossMarginPct: 0.4879,
    grossProfit: 1206.09,
    commissionPercentage: 4.00,
    salesCommission: 98.88,
    salesManagerFee: 24.72,
    companyOH: 383.16,
    netProfit: 0
  },
  {
    jobInfo: "E-503: Theresa Bean",
    leadSource: "Thumbtack",
    trade: "Gutters",
    contractTotal: 986.00,
    grossMarginPct: 0.5426,
    grossProfit: 535.00,
    commissionPercentage: 7.00,
    salesCommission: 69.02,
    salesManagerFee: 9.86,
    companyOH: 152.83,
    netProfit: 0
  },
  {
    jobInfo: "E-466: DJ & Joyce Glattke",
    leadSource: "Angi",
    trade: "Roofing",
    contractTotal: 10089.00,
    grossMarginPct: 0.4568,
    grossProfit: 4608.66,
    commissionPercentage: 4.00,
    salesCommission: 403.56,
    salesManagerFee: 100.89,
    companyOH: 1563.80,
    netProfit: 0
  },
  {
    jobInfo: "E-473: Linda McClellan",
    leadSource: "Truck",
    trade: "Siding",
    contractTotal: 20082.00,
    grossMarginPct: 0.5071,
    grossProfit: 10183.58,
    commissionPercentage: 7.00,
    salesCommission: 1405.74,
    salesManagerFee: 200.82,
    companyOH: 3112.71,
    netProfit: 0
  },
  {
    jobInfo: "E-498: Kevin & Debbie Linares",
    leadSource: "Yelp",
    trade: "Gutters",
    contractTotal: 3472.00,
    grossMarginPct: 0.3503,
    grossProfit: 1216.24,
    commissionPercentage: 0.00,
    salesCommission: 0.00,
    salesManagerFee: 34.72,
    companyOH: 538.16,
    netProfit: 0
  },
  {
    jobInfo: "E-458: Justin & April Smith",
    leadSource: "Thumbtack",
    trade: "Attic Insulation",
    contractTotal: 9482.30,
    grossMarginPct: 0.5944,
    grossProfit: 5636.28,
    commissionPercentage: 7.00,
    salesCommission: 663.76,
    salesManagerFee: 94.82,
    companyOH: 1469.76,
    netProfit: 0
  },
  {
    jobInfo: "E-449: Jason & Amanda Hoff",
    leadSource: "Google Organic Search",
    trade: "Attic Insulation",
    contractTotal: 7967.80,
    grossMarginPct: 0.7281,
    grossProfit: 5801.36,
    commissionPercentage: 10.00,
    salesCommission: 796.78,
    salesManagerFee: 79.68,
    companyOH: 1235.01,
    netProfit: 0
  },
  {
    jobInfo: "Fredia Green",
    leadSource: "Homebuddy",
    trade: "Windows & Doors",
    contractTotal: 21872.00,
    grossMarginPct: 0.4000,
    grossProfit: 8748.80,
    commissionPercentage: 4.00,
    salesCommission: 874.88,
    salesManagerFee: 218.72,
    companyOH: 3390.16,
    netProfit: 0
  },
  {
    jobInfo: "Spencer & Katherine Lauterbach",
    leadSource: "Yelp",
    trade: "Windows & Doors",
    contractTotal: 4472.00,
    grossMarginPct: 0.4000,
    grossProfit: 1788.80,
    commissionPercentage: 4.00,
    salesCommission: 178.88,
    salesManagerFee: 44.72,
    companyOH: 693.16,
    netProfit: 0
  },
  {
    jobInfo: "Leonard & Rochelle Guedalia",
    leadSource: "Web to Lead Form",
    trade: "Roofing",
    contractTotal: 25621.00,
    grossMarginPct: 0.4000,
    grossProfit: 10248.40,
    commissionPercentage: 4.00,
    salesCommission: 1024.84,
    salesManagerFee: 256.21,
    companyOH: 3971.26,
    netProfit: 0
  }
];

// Apply Standard report calculation formula
// Net Profit = Gross Profit - (Sales Commission + Sales Manager Fee + Company OH)
jobData.forEach(job => {
  job.netProfit = job.grossProfit - (job.salesCommission + job.salesManagerFee + job.companyOH);
});

// Use the totals from the CSV file
const totalContractValue = 339249.17;  // From CSV totals row
const totalGrossProfit = 162558.48;    // From CSV totals row
const totalSalesCommissions = 17305.84; // From CSV totals row
const totalManagerFees = 3392.49;      // From CSV totals row
const totalCompanyOH = 52583.62;       // From CSV totals row

// Calculate net profit before ad spend using the Standard formula
const totalNetProfitBeforeAdSpend = totalGrossProfit - (totalSalesCommissions + totalManagerFees + totalCompanyOH);

// Ad spend data
const adSpendData = [
  { source: "Google Organic Search", spend: 3500.00 },
  { source: "Porch", spend: 300.36 },
  { source: "Guild Quality", spend: 0.00 },
  { source: "Networx", spend: 5015.00 },
  { source: "Contractor Appointment", spend: 0.00 },
  { source: "Homebuddy", spend: 3286.00 },
  { source: "Thumbtack", spend: 15600.00 },
  { source: "Web to Lead Form", spend: 13070.00 },
  { source: "Yelp", spend: 5558.21 },
  { source: "Google AdWords", spend: 3000.60 },
  { source: "Google LSA", spend: 331.00 },
  { source: "BBB", spend: 300.00 },
  { source: "Lead2Performance", spend: 0.00 },
  { source: "Buyerlink", spend: 1030.00 },
  { source: "Facebook / Meta Ads", spend: 4547.47 },
  { source: "Angi", spend: 2530.00 }
];

const totalAdSpend = 58068.64; // From CSV header

// Calculate final net profit after ad spend
const totalNetProfit = totalNetProfitBeforeAdSpend - totalAdSpend;

// Aggregate sales by source
const salesBySourceMap = jobData.reduce((acc, job) => {
  const source = job.leadSource;
  if (!acc[source]) {
    acc[source] = {
      source,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[source].totalSales += job.contractTotal;
  acc[source].count += 1;
  acc[source].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { source: string; totalSales: number; count: number; grossProfit: number }>);

const salesBySource = Object.values(salesBySourceMap);

// Aggregate sales by trade
const salesByTradeMap = jobData.reduce((acc, job) => {
  const trade = job.trade;
  if (!acc[trade]) {
    acc[trade] = {
      trade,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[trade].totalSales += job.contractTotal;
  acc[trade].count += 1;
  acc[trade].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { trade: string; totalSales: number; count: number; grossProfit: number }>);

const salesByTrade = Object.values(salesByTradeMap);

// Export the final report data object
export const julyData: ReportData = {
  kpis: {
    adSpend: totalAdSpend,
    totalSales: totalContractValue,
    grossProfit: totalGrossProfit,
    salesCommissions: totalSalesCommissions,
    managerFees: totalManagerFees,
    companyOH: totalCompanyOH,
    netProfit: totalNetProfit,
    netProfitPercent: totalNetProfit / totalContractValue,
    grossProfitPercent: totalGrossProfit / totalContractValue
  },
  adSpendBySource: adSpendData,
  salesBySource: salesBySource,
  salesByTrade: salesByTrade,
  jobData: jobData,
  period: {
    month: 7, // July
    year: 2025
  }
};